export const isThereAnyGenericProductWithZero = (products) => {
    const getProductGenerics = products?.some(({ quantity, generics }) => {
        return generics?.length > 0 && quantity === 0;
    });

    return getProductGenerics;
};
